import React, { useState } from 'react';
import { connect } from "react-redux";

import { TextField } from "@mui/material";
import { Button } from "@mui/material";

import {
  putGlobalIaac,
} from "../store/actions";

const EditGlobalIaaC = (props) => {
  console.log("GlobalIaaC props=", props);
  const { subscriptions } = props.iaac;
  const [iaacSubscriptionData, setIaacSubscriptionData] = useState(subscriptions);

  const rows = [
    {
      id: 'price',
      basic: iaacSubscriptionData.find(sub => sub.subscription === 'Basic').price,
      standard: iaacSubscriptionData.find(sub => sub.subscription === 'Standard').price,
      premium: iaacSubscriptionData.find(sub => sub.subscription === 'Premium').price,
    },
    {
      id: 'limit',
      basic: iaacSubscriptionData.find(sub => sub.subscription === 'Basic').limit,
      standard: iaacSubscriptionData.find(sub => sub.subscription === 'Standard').limit,
      premium: iaacSubscriptionData.find(sub => sub.subscription === 'Premium').limit,
    },
  ];

  const handleIaacModelChange = (e, iaacParameter, plan) => {
    const updatedData = [...iaacSubscriptionData];
    const targetParameterRow = updatedData.find((row) => row.subscription === plan);
    targetParameterRow[iaacParameter] = parseInt(e.target.value);
    console.log("~ updatedData iaac subscription, after change ", updatedData);
    setIaacSubscriptionData(updatedData);
  };

  const handleUpdateGlobalIaac = (e) => {
    e.preventDefault();
    const updateGlobalIaac = {
      subscriptions: iaacSubscriptionData
    }
    console.log("Submitting data for updating Global Iaac: ", updateGlobalIaac);
    props.putGlobalIaac(updateGlobalIaac);
  }


  return (
    <div>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Basic</th>
            <th>Standard</th>
            <th>Premium</th>
          </tr>
        </thead>
        <tbody>
          {
            rows.map( (iaacParameter, index) => (
              <tr key={iaacParameter.id}>
                <td>{iaacParameter.id.charAt(0).toUpperCase() + iaacParameter.id.slice(1)}</td>
                <td>
                  <TextField 
                      variant="outlined"
                      size="small"
                      type="number"
                      value={iaacParameter.basic}
                      onChange={(e) => handleIaacModelChange(e, iaacParameter.id, "Basic")}
                    />
                </td>
                <td>
                  <TextField 
                      variant="outlined"
                      size="small"
                      type="number"
                      value={iaacParameter.standard}
                      onChange={(e) => handleIaacModelChange(e, iaacParameter.id, "Standard")}
                    />
                </td>
                <td>
                  <TextField 
                      variant="outlined"
                      size="small"
                      type="number"
                      value={iaacParameter.premium}
                      onChange={(e) => handleIaacModelChange(e, iaacParameter.id, "Premium")}
                    />
                </td>
              </tr>
            ) )
          }
        </tbody>
      </table>
      <Button
        type="submit"
        variant="contained"
        disabled={props.isUpdatingGlobalIaac}
        onClick={handleUpdateGlobalIaac}
      >
        Update
      </Button>
    </div>
  )
}

const mapStateToProps = (state) => {
  const {
    isUpdatingGlobalIaac,
    updateGlobalIaacMessage,
    updateGlobalIaacError,
  } = state.globalIaac;
  return {
    isUpdatingGlobalIaac,
    updateGlobalIaacMessage,
    updateGlobalIaacError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    putGlobalIaac: (globalIaac) => {
      dispatch(putGlobalIaac(globalIaac));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditGlobalIaaC);